<template>
  <div>
    <label v-if="label" class="form-label mb-3" :for="id">{{ label }} <span v-if="required">*</span> :</label>
    <label :value="option.value" v-for="(option, key) in optionsFormatted" v-bind:key="key" class="mr-3 mb-2">
      <div class="inline-block pb-2">
        <input class="mr-1" :value="modelValue" type="radio" :name="label" :checked="option.value == modelValue"
               @input="$emit('update:modelValue', parseInt(option.value))">{{option.label}}
      </div>
    </label>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  name: 'RadioHorizontal',
  props: {
    options: Object,
    id: {
      type: String,
    },
    value: [String, Number, Boolean],
    label: String,
    error: String,
    modelValue: Number,
    required: Boolean
  },
  data() {
    return {
      selected: this.value,
    }
  },
  emits: ['update:modelValue'],
  computed: {
    optionsFormatted(){
      let arr = []
      for (let elm of this.options) {
        arr.push({'label': elm.name, 'value': elm.id})
      }
      return arr
    }
  },
  watch: {
    selected(selected) {
      this.$emit('input', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style scoped>

</style>
